module.exports = __webpack_public_path__ + "img/img2_gr.8e730837.png";